module.exports = __webpack_public_path__ + "static/media/5_cochin.35e44c63.svg";